<template lang="html">
  <div class="form">
    <div class="content">
      <div class="form-hd">填写信息</div>
      <div class="form-row">
        <span class="form-col-head">申请人</span>
        <div class="form-col-value">
          <input
            placeholder="请输入您的姓名"
            v-model="applyInfo.name"
            maxlength="16"
          />
        </div>
      </div>
      <div class="form-row">
        <span class="form-col-head">联系电话</span>
        <div class="form-col-value">{{ mobile }}</div>
      </div>
      <div class="form-row">
        <span class="form-col-head">入驻城市</span>
        <div
          class="form-col-value ui-toright"
          :class="{ hasplaceholder: !serverCity || !serverCity.NAME }"
          @click="selectCity"
        >
          {{
            serverCity && serverCity.NAME
              ? serverCity.NAME
              : '请选择您要服务的城市'
          }}
        </div>
      </div>
      <div class="form-row">
        <span class="form-col-head">入驻门店</span>
        <div
          class="form-col-value ui-toright"
          :class="{ hasplaceholder: !nearbyStore.store_desc }"
          @click="selectStore"
        >
          {{
            nearbyStore.store_desc
              ? nearbyStore.store_desc
              : '请选择离你最近的门店'
          }}
        </div>
      </div>
      <div class="form-row">
        <span class="form-col-head">推荐人</span>
        <div class="form-col-value">{{ tuser }}</div>
      </div>
      <div class="nextStep" @click="submit">立刻入驻</div>
    </div>
    <pageAction :viewName="viewName" v-if="show"></pageAction>
    <actionSheet :viewName="viewName" :params="params" v-else></actionSheet>
    <loading :visible="visible"></loading>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { Msgbox } from 'kf-component-vue'
import loading from '@/components/common/loading/custome-loading'
import pageAction from '../actionSheet/pageAction'
import actionSheet from '../actionSheet'

export default {
  props: {
    stepNo: {
      type: [Number, String],
      default: 0
    },
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      visible: false,
      show: true,
      params: {},
      active: false,
      pics: [],
      tips: '',
      clicked: false,
      tuser: '无',
      applyInfo: {},
      puid: this.$route.query.puid || ''
    }
  },
  async beforeCreate() {
    this.$$title('完善个人信息')
    this.puid = this.$route.query.puid || ''
  },
  computed: {
    ...mapState(['viewName', 'serverCity', 'nearbyStore']),
    mobile() {
      return this.mobileDisplay(this.$$cookie('phone') || '')
    }
  },
  created() {
    this.applyInfo.mobile =
      this.info.applierPhone || this.$$cookie('phone') || ''
    this.applyInfo.name = ''
    this.applyInfo.serveCity = {}
    this.applyInfo.serveCategory = []
    this.applyInfo.storeName = ''
    this.applyInfo.storeCode = ''
    this.tuser = this.info.recommendDesc || '无'
    this.$$loading(false)
  },
  watch: {
    serverCity(val, oldVal) {
      if (val.ID !== oldVal.ID) {
        this.$store.commit('setNearbyStore', {})
      }
    }
  },
  methods: {
    ...mapMutations([
      'hideActionSheet',
      'showActionSheet',
      'changeView',
      'setActionHeader'
    ]),
    display(text) {
      return text.replace(/\n/g, '<br/>')
    },
    mobileDisplay(mobile) {
      const str = `${mobile}`
      return `${str.substr(0, 3)}-${str.substr(3, 4)}-${str.substr(7, 4)}`
    },
    selectCity() {
      this.show = true
      this.changeView('enteringCity')
      this.setActionHeader({
        title: '选择城市',
        show: false
      })
      this.$router.push({
        query: { ...this.$route.query, action: true, viewName: this.viewName }
      })
    },
    selectStore() {
      if (!this.serverCity || !this.serverCity.NAME) {
        return this.$$toast('请选择服务的城市')
      }
      this.show = false
      this.params = {
        cityId: this.serverCity.ID,
        selectedId: this.nearbyStore.store_code
      }
      this.changeView('storeSheet')
      this.setActionHeader({
        title: '请选择离你最近的门店',
        show: false
      })
      if (this.clicked) {
        this.showActionSheet()
      }
      this.clicked = true
    },
    async submit() {
      this.visible = true
      const { uid, skey } = await this.$$ensureLogin()
      this.applyInfo.managerUid = this.$route.query.puid || 0
      this.applyInfo.uid = uid
      this.applyInfo.skey = skey
      this.applyInfo.tkey = this.$route.query.hserecomkey || ''

      if (!this.applyInfo.name || !this.applyInfo.name.trim()) {
        this.visible = false
        return this.$$toast('请输入您的姓名')
      }
      if (!this.serverCity || !this.serverCity.ID) {
        this.visible = false
        return this.$$toast('请选择服务的城市')
      }
      if (!this.nearbyStore || !this.nearbyStore.store_code) {
        this.visible = false
        return this.$$toast('请选择离你最近的门店')
      }
      this.toDoSubmit()
    },
    async toDoSubmit() {
      // this.visible = true
      if (this.serverCity) {
        const provinceId = `${this.serverCity.ID.toString().slice(0, 2)}0000`
        const province = await this.$store.dispatch('getNameById', {
          addressId: provinceId
        })
        if (!province) {
          this.visible = false
          return this.$$toast('系统接口错误，请稍后再试！')
        }
        this.applyInfo.serveCity = {
          provinceId: province.ID,
          cityId: this.serverCity.ID,
          provinceName: province.NAME,
          cityName: this.serverCity.NAME
        }
      }

      if (this.applyInfo.serveCategory) {
        const selectedCate = []
        this.applyInfo.serveCategory.forEach(cate => {
          if (typeof cate === 'object') {
            selectedCate.push(cate)
          } else {
            const serveCategory = this.categoryList
            const res = serveCategory.filter(o => o.categoryId === cate)
            selectedCate.push(res[0])
          }
        })
        this.applyInfo.serveCategory = selectedCate
      }
      this.applyInfo.storeCode = this.nearbyStore.store_code
      this.applyInfo.storeName = this.nearbyStore.store_desc

      console.log(this.applyInfo)
      const info_res = await this.$store.dispatch('saveBasicInfo', {
        info: this.applyInfo
      })
      this.visible = false
      if (info_res.code * 1 === 1) {
        location.replace(
          `/v/yuesao/step1?puid=${this.info.managerUid || ''}&hserecomkey=${
            this.info.tkey || ''
          }`
        )
      } else if (info_res.code * 1 === 4) {
        this.$$login()
      } else {
        this.$$toast(info_res.msg)
      }
    }
  },
  components: {
    pageAction,
    actionSheet,
    loading
  }
}
</script>
<style lang="scss">
@import '../../assets/css/mixin';
#app,
#vproduct_app {
  background-color: #ffa19c;
}
.of-hide {
  overflow: hidden;
}
.content {
  ::-webkit-input-placeholder {
    color: #999 !important;
  }
  .kfc-checkbox {
    display: inline-flex;
    width: rem(290px);
    margin-bottom: rem(10px);
    .kfc-checkbox__label {
      flex: 1;
      i {
        color: #ff397e;
      }
    }
  }
  .mint-checklist {
    .mint-cell {
      display: inline-block;
      width: rem(290px);
    }
  }
  .mint-cell-wrapper .mint-checkbox-input:checked + .mint-checkbox-core {
    background-color: #ff6ea2;
    border-color: #ff6ea2;
    color: #fff;
  }
  .mint-cell-wrapper .mint-checkbox-input:checked + .mint-checkbox-core::after {
    border-color: #fff !important;
  }
  .mint-cell-wrapper .mint-checkbox-core {
    border-radius: rem(4px) !important;
  }
  .mint-cell-wrapper {
    padding-left: 0 !important;
    padding-right: rem(10px) !important;

    .mint-field-core {
      color: #999 !important;
    }

    .mint-checkbox-label,
    .mint-radio-label {
      color: #999 !important;
      margin-left: rem(8px);
    }
  }
  input {
    height: rem(100px);
    width: 100%;
  }
}
.kfcv-msgbox {
  line-height: 1.2 !important;
  .kfcv-msgbox-core {
    width: rem(560px) !important;
    .kfcv-msgbox-content {
      padding: rem(40px) rem(40px) 0.3rem;
    }
    .kfcv-msgbox-message {
      max-height: rem(500px) !important;
      overflow-y: auto !important;
      overflow-x: hidden !important;
      overscroll-behavior: contain;
    }
  }
  .kfcv-msgbox-message {
    margin-top: 0 !important;
    text-align: left;
    .sku-item {
      margin-top: rem(20px);
      @include border(bottom);
      padding-bottom: rem(30px);
      .sku-item-name {
        font-size: rem(30px);
        color: #121212;
        i {
          color: #ff6ea2;
        }
      }
      .sku-item-desc {
        margin-top: rem(20px);
        font-size: rem(30px);
        color: #666;
      }
    }
    .sku-item:last-child {
      padding-bottom: 0 !important;

      &:after {
        border: 0;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.form {
  background: #ffa19c url('../../assets/images/enter-yuesao-bg.png') 0 0
    no-repeat;
  background-size: contain;
  background-color: #ffa19c;
  padding-top: rem(260px);
  padding-left: rem(25px);
  padding-right: rem(25px);
  // padding-bottom: rem(70px);
}
.content {
  background-color: #fff;
  padding-bottom: rem(30px);
  border-radius: rem(14px) rem(16px) rem(16px) rem(16px);

  .form-hd {
    color: #121212;
    font-weight: 600;
    font-size: rem(32px);
    margin-left: rem(30px);
    padding-top: rem(30px);
  }
  .form-row {
    @include border(bottom);
    margin-left: rem(30px);
    margin-right: rem(30px);
    font-size: 0;

    .form-col-head {
      display: inline-block;
      // padding-left:rem(10px);
      padding-top: rem(30px);
      padding-bottom: rem(30px);
      color: #666;
      min-width: rem(170px);
      font-size: rem(32px);
      line-height: 1.25;

      button {
        width: rem(110px);
        height: rem(32px);
        text-align: center;
        line-height: rem(32px);
        color: #666;
        font-size: rem(22px);
        @include border(all, #ccc, 1px, 2px);
        // border-radius: rem(4px);
      }
      // button::before{
      //     border-radius: rem(4px) !important;
      // }
    }
    .form-col-desc {
      font-size: rem(24px);
      color: #ff6ea2;
    }
    .form-col-value {
      color: #121212;
      width: rem(460px);
      display: inline-block;
      font-size: rem(32px);
      word-wrap: break-word;
      word-break: break-all;
      line-height: 1.25;
    }
    .form-col-value.hasplaceholder {
      color: #999 !important;
    }

    .form-col-service {
      padding-left: rem(60px);

      .form-col-service-others {
        padding-top: rem(22px);
        font-size: rem(32px);
        color: #999;
      }
      .form-col-service-others-value {
        // min-height:rem(80px);
        @include border(bottom);

        input {
          height: rem(60px);
        }
      }
      .form-col-tips {
        padding-top: rem(12px);
        color: #ff6ea2;
        font-size: rem(26px);
      }
    }
  }

  .no-border {
    &:after {
      border: none !important;
    }
  }
  .ui-toright:after {
    font-family: iconfont !important;
    font-size: 18px;
    line-height: 45px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    display: block;
    color: rgba(0, 0, 0, 0.5);
    color: #999;
    content: '\e6d5';
    position: absolute;
    right: 19px;
    top: 50%;
    margin-top: -22px;
    margin-right: -10px;
  }
  .ui-delete:after {
    font-family: iconfont !important;
    font-size: 16px;
    line-height: 45px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    display: block;
    color: rgba(0, 0, 0, 0.5);
    color: #999;
    content: '\e6d7';
    position: absolute;
    right: 15px;
    top: 50%;
    margin-top: -22px;
    margin-right: -10px;
  }
}
.nextStep {
  // position: fixed;
  // bottom: 0;
  // left:0;
  margin: rem(72px) rem(30px) 0 rem(30px);
  // width:100%;
  height: rem(100px);
  background-color: #ff6ea2;
  text-align: center;
  line-height: rem(100px);
  color: #fff;
  font-size: rem(36px);
}
</style>
